import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl'
import LocaleContext from '../../state/contexts/LocaleContext'
import { messages } from './UserAdminContainer.i18n'
import styled, { keyframes, css } from 'styled-components'
import  EditProfile  from './editProfile/EditProfile'
import SearchComponent from './search/SearchComponent';
import SearchResultComponent from './searchResult/SearchResultComponent'
import useUserAdminReducer from './useUserAdminReducer'
import { Alert } from "react-bootstrap";

const SearchContainer = styled.div`
    display: flex;
    gap: 20px;
    align-items: flex-start;
`;

const SearchSection = styled.div`
    flex: ${({ fullwidth }) => (fullwidth ? '1' : '0.31')};
    min-width: 300px;
    transition: flex 0.5s ease;
`;

const slideIn = keyframes`
    from {
        opacity: 0;
        transform: translateX(100%);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
`;

const ResultSection = styled.div`
    flex: 0.7;
    min-width: 300px;
    opacity: ${({ isvisible }) => (isvisible ? 1 : 0)};
    transition: opacity 0.5s ease;
    ${({ animate }) =>
        animate &&
        css`
            animation: ${slideIn} 0.5s ease-out forwards;
        `}
    display: ${({ isvisible }) => (isvisible ? 'block' : 'none')};
`;

const UserAdminContainer = (props) => {

    const locale = React.useContext(LocaleContext);

    const { state, displayForms, resetContainer, showSearchForm, gotoSearchResult, 
        searchUsers, deleteUsers, setCurrentUser, getUser, updateUser, createUser, deleteUser, 
        getKreditorListe, isAdminKreditor, copyKonserAdmin, toggleSelectedDelete, toggleAllSelectedDelete 
    } = useUserAdminReducer(messages[locale])

    // klikk på menyen setter en prop med random verdi for å tvinge rerender av aktiv form
    useEffect(() => {
        //console.log('***RESET form***', JSON.stringify(props))
        resetContainer();
    }, [props]);

    // Holder styr på om søk har blitt gjort. Om første søk animerers søkeresultatene inn, om søk allerede er utført skal ikke animasjon skje på nytt
    const [firstSearch, setFirstSearch] = useState(true);
    const [isSearchPerformed, setIsSearchPerformed] = useState("");
 
    return (

        <IntlProvider locale={locale} messages={messages[locale]}>

            {state.error && <Alert variant='danger'>{state.error}</Alert>}

            {state.savedMessage && <Alert variant='info'>{state.savedMessage}</Alert>}
            {(state.activeForm === displayForms.SEARCHFORM || state.activeForm === displayForms.SEARCHRESULT) &&
                <SearchContainer>
                <SearchSection fullwidth={!isSearchPerformed}>
                    <SearchComponent
                        searchUsers={searchUsers}
                        createUser={createUser}
                        isAdminKreditor={isAdminKreditor}
                        copyKonserAdmin={copyKonserAdmin}
                        state={state}
                        firstSearch={firstSearch}
                        isSearchPerformed={isSearchPerformed}
                        onSearch={() => {
                            if (firstSearch) setFirstSearch(false);
                            setIsSearchPerformed("true");
                        }}
                    />
                </SearchSection>
                 <ResultSection isvisible={isSearchPerformed} animate={firstSearch}>
                    <SearchResultComponent
                        setCurrentUser={setCurrentUser}
                        users={state.users}
                        loading={state.loading}
                        showSearchForm={showSearchForm}
                        toggleSelectedDelete={toggleSelectedDelete}
                        toggleAllSelectedDelete={toggleAllSelectedDelete}
                        deleteUsers={deleteUsers}
                    />
                </ResultSection>
            </SearchContainer>
            }

            {(state.activeForm === displayForms.EDITFORM) &&
                <EditProfile
                    formValues={state.user}
                    foreningkreditorListe={state.currentForeningKreditorListe}
                    updateUser={updateUser}
                    createUser={createUser}
                    deleteUser={deleteUser}                    
                    getKreditorListe={getKreditorListe}
                    gotoSearchResult={gotoSearchResult}
                    loading={state.loading}
                    state={state}
                />    
            }

            {/*
            {JSON.stringify(props)}
            {state.activeForm}
            {JSON.stringify()}
             */} 

        </IntlProvider>
    )
}

export default UserAdminContainer